import api from './api';

export const listAllAnnouncements = () =>
  api.get('/admin/hub-announcements').then(r => r.data.announcements);

export const createAnnouncement = (fields) =>
  api.post('/admin/hub-announcements', fields).then(r => r.data);

export const updateAnnouncement = (id, fields) =>
  api.put(`/admin/hub-announcement/${id}`, fields).then(r => r.data);

export const deleteAnnouncement = (id) =>
  api.delete(`/admin/hub-announcement/${id}`);

export const bulkImportAnnouncements = (csvText) =>
  api.post('/admin/hub-announcements/bulk-import', { csv: csvText }).then(r => r.data);

export const bulkCreateAnnouncements = (rows) =>
  api.post('/admin/hub-announcements/bulk-import', { rows }).then(r => r.data);
